// URLs
export const LOGIN_URL = "/login";
export const ONEPASS_LEARN_MORE = "/onepass";
export const ONEPASS_TERMS_AND_CONDITIONS = "/onepass-terms";
export const ONEPASS_OAUTH_REDIRECT = "/oauth_redirect/onepass";
export const ONEPASS_SUBSCRIBE_URL = "/onepass/subscribe";
export const ONEPASS_CONSENT_URL = "/onepass-consent";

// Analytics
export const DEFAULT_CLUB_CATCH_EVENT_ID = 3;
export const DEFAULT_CATCH_SELLER_ID = 1;

// Query Params
export const ONEPASS_MIGRATION_STATUS_QUERY_PARAM_KEY =
  "onepass-migration-status";
export const ONEPASS_DOUBLE_SUBSCRIPTION_QUERY_PARAM_KEY = "double-sub";
export const ONEPASS_LINK_QUERY_PARAM_KEY = "link-onepass";
export const ONEPASS_SUCCESS_NOTIFICATION_TOAST_PARAM_KEY = "showmessage";

// Others
export const ONEPASS_HOTLINE_NO = "1300 222 824";

//EXPERIMENTS
export const PERSONALISED_RECOMMENDER_TITLE_EXPERIMENT =
  "personalised_recommender_title_july_2022";
